import React from "react";
import {
  Table,
  message,
  Button,
  Form,
  Input
} from "antd";
import { httpGet, httpDelete } from "../../http";

import "./profiles.css"
const { Search } = Input;

class ListForm extends React.Component {
  state = {
    modalVisibleAdd: false,
    modalTitleAdd: "",
    editValues: {},
    modalVisibleBind: false,
    modalTitleBind: "",
    editBind: {},
    modalVisibleTime: false,
    selectedRowKeys: [],
    data: [],
    type: "person",
    pageSize: 10
  };

  componentDidMount() {
    this.getWorkersList(0);
  }

  getWorkersList = () => {
    httpGet("/api/v1/workers/")
      .then( res => {
        if (res.status === 200) {
          return res.json();
        } else {
          message.error("Interface error: get_workers_list");
        }
        
      })
      .then( data => {
        this.setState({
          data: data
        });
        
      })
      .catch((err) => {
        message.error("Interface error: get_workers_list");
      });
  };

  downloadWorkersList = () => {
    let url = "/api/v1/worker/download";
    window.open(url);
  };

  handleModalVisibleAdd = (flag, title, record) => {
    this.setState({
      modalVisibleAdd: !!flag,
      modalTitleAdd: title,
      editValues: record || {},
    });
  };

  handleModalVisibleBind = (flag, title, record) => {
    this.setState({
      modalVisibleBind: !!flag,
      modalTitleBind: title,
      editBind: record || {},
    });
  };

  handleModalVisibleTime = (flag, worker_id, type) => {
    console.log(worker_id)
    this.setState({
      modalVisibleTime: !!flag,
      selectedRowKeys: worker_id,
      type: type
    });
  };

  delete_confirm = (id) => {
    httpDelete("/api/v1/workers/" + id + "/")
      .then( res => {
        if (res.status === 204) {
          message.info("Delete Success!");
          this.getWorkersList();
        } else {
          message.error("Interface error: delete_worker");
        }
      })
      .catch((err) => {
        message.error("Interface error: delete_worker");
      });
  };

  columns = [
    {
      title: "On/Off",
      dataIndex: "onsite",
      align: "center",
      key: "onsite",
      render: (text, record) => (
        <span>
          {record.device && record.device.onsite ? <b className="green"></b> : <b className="red"></b>}
        </span>
      ),
      sorter: (a, b) => ((a.device ? a.device.onsite : false) - (b.device ? b.device.onsite : false))
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "NRIC/Fin no",
      dataIndex: "nric",
      key: "nric",
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (text, record) => (
        <span>{record.type && (record.type.slice(0,1).toUpperCase() + record.type.slice(1).toLowerCase())}</span>
      )
    },
    {
      title: "Employ ID",
      dataIndex: "company",
      key: "company",
    },
    {
      title: "Device Label",
      dataIndex: "device_label",
      key: "device_label",
      align: "center"
    }
  ];

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onSearch = (value) => {
    let workerSearch = this.state.data.filter((item, index) => {
      let name = item.name.toUpperCase().indexOf(value.toUpperCase()) !== -1 ;
      if (name) {
        return item;
      }
      return ''
    });

    if (workerSearch.length > 0) {
      this.setState({
        data: workerSearch,
      });
    } else {
      message.error("error: please enter the correct content");
    }
  };
  resetWorkList = () => {
    this.refs.search.input.state.value= undefined
    this.getWorkersList(0)
  };
  onShowSizeChange = (current, size) => {
    this.setState({
      pageSize: size
    })
  }

  render() {

    return (
      <div className="box profiles">
        <div className="table-operations">
          <Search
            ref="search"
            placeholder="Search"
            enterButton
            onSearch={this.onSearch}
            style={{ width: 300, marginLeft: 10, display: 'none'}}
           
          />
          <Button 
            onClick={() => this.resetWorkList()} 
            type="primary"
            style={{ marginLeft: 1, display: 'none' }}>
            Reset
          </Button>

          <Button 
            icon="download" 
            onClick={() => this.downloadWorkersList()} 
            type="primary"
            style={{display: 'none'}}
            >Download</Button>
        </div>
        <Table
          rowKey={(record) => record.id}
          columns={this.columns}
          dataSource={this.state.data}
          pagination={
            {
              pageSize: this.state.pageSize,
              showSizeChanger: true,
              onShowSizeChange: this.onShowSizeChange
            }
          }
        ></Table>
      </div>
    );
  }
}

const Profiles = Form.create({ name: "add_record" })(ListForm);
export default Profiles;
